import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useMissionContext } from './context/MissionContext';
import MobileShell from './components/layout/MobileShell';
import HomeDashboard from './pages/HomeDashboard';
import MissionsListPage from './pages/MissionsListPage';
import CalendarPage from './pages/CalendarPage';
import MissionDetailPage from './pages/MissionDetailPage';
import InspectionPage from './pages/InspectionPage';
import { NoteDeFraisPage, NouveauRapportPage } from './pages/AuxPages';

export default function AuthenticatedRoutes() {
  const { isLoading } = useMissionContext();

  if (isLoading) {
    return (
      <div className="app">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column',
            gap: '20px',
          }}
        >
          <div className="spinner-large"></div>
          <p>Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route element={<MobileShell />}>
        <Route index element={<HomeDashboard />} />
        <Route path="missions" element={<MissionsListPage />} />
        <Route path="calendrier" element={<CalendarPage />} />
      </Route>
      <Route path="/mission/:missionId" element={<MissionDetailPage />} />
      <Route path="/mission/:missionId/inspection" element={<InspectionPage kind="electricite" />} />
      <Route path="/mission/:missionId/inspection/levage" element={<InspectionPage kind="levage" />} />
      <Route path="/mission/:missionId/inspection/thermo" element={<InspectionPage kind="thermo" />} />
      <Route path="/notes-frais" element={<NoteDeFraisPage />} />
      <Route path="/nouveau-rapport" element={<NouveauRapportPage />} />
    </Routes>
  );
}
